'use es6';

import { FINDER_OPEN_ACTION_MODAL, FINDER_CLOSE_ACTION_MODAL } from 'DesignData/actions/ActionTypes';
export function openActionModal(modal) {
  return {
    type: FINDER_OPEN_ACTION_MODAL,
    modal
  };
}
export function closeActionModal() {
  return {
    type: FINDER_CLOSE_ACTION_MODAL
  };
}